export default "__VITE_ASSET__89176813__"